import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../../base/store/actions';

export default class UpsellTrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/upsell-tracking`;

    private static readonly UPSELL_TRACKING = `${UpsellTrackingActions.ACTION_SCHEMA}/UPSELL_TRACKING`;

    static track = createAction(UpsellTrackingActions.UPSELL_TRACKING, props<{ eventDetails: string; action?: string }>());
}
